<template>
    <!-- <div class="visual">
        <ul>
            <li>
                <div class="visual__contant">
                    <div class="container">
                        <div class="visual__con-wrap">
                            <div class="visual__con-img">
                                <img src="/images/logo2.svg" alt="KEA전자제조지원센터 전자혁신제조플랫폼">
                            </div>
                            <div class="visual__con">
                                <h2 class="visual__tit">한국전자정보통신산업진흥회(KEA)<br/>전자제조센터</h2>
                                <p class="visual__txt">무궁무진한(=다옴없다) 전자제품의 혁신과 제조과정을 지원합니다.</p>
                            </div>
                        </div>
                        <div class="visual__background" style="background-image:url(/images/main/v1.png);"></div>
                    </div>
                </div>
            </li>
        </ul>
        <slot />
    </div> -->
    <div v-if="banner && ((pc && isPc) || (mobile && isMobile))" class="main-visual swiper-container">
        <div class="swiper-wrapper">
            <div v-for="(slide, index) in banner.slides" :key="index" class="swiper-slide">
                <component :is="dynamicComponent(slide.url)" :to="slide.url" :href="slide.url">
                    <picture>
                        <source :srcset="slide.image" media="(max-width:1200px)">
                        <img :src="slide.image" alt="">
                    </picture>
                </component>
            </div>
        </div>
        <div class="main-visual__controls">
            <div class="main-visual__prev"></div>
            <div class="main-visual__next"></div>
            <!-- <div class="pagination"></div> -->
        </div>
    </div>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
export default {
    props: {
        pc: Boolean,
        mobile: Boolean,
    },
    data(){
        return{
            detect,
            banner: null,
            width: window.innerWidth,
        }
    },
    computed: {
        isPc(){
            return this.width >= 768;
        },
        isMobile(){
            return this.width <768;
        },
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { banner } = await api.v1.banners.get({ code: this.$attrs.code, params: { sites: this.$attrs.sites } });
            this.banner = banner;

            this.$nextTick(() => {
                var mainVisual = new Swiper ('.main-visual', {
                    allowTouchMove: false,
                    centeredSlides: true,
                    spaceBetween : 0,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 300,
                    loop: true,
                    pagination: {
                        el: '.main-visual .pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.main-visual__next',
                        prevEl: '.main-visual__prev'
                    },
                    breakpoints: {
                        1200: {
                            allowTouchMove: true,
                        }
                    }
                });
            });

            window.addEventListener("resize", this.setWidth);
        },
        dynamicComponent(url){
            return (url || '').indexOf("/") == 0 ? "router-link" : "a";
        },
        setWidth(){
            this.width = window.innerWidth;
        }
    },
    destroyed(){
        window.removeEventListener("resize", this.setWidth)
    }
};
</script>